import { z } from 'zod'

/**
| Tenant | Region  | Sub Tenant | App Name    | Enum Value                 |
|--------|---------|------------|-------------|----------------------------|
| wpus   | usa     | whirl      | campaigning | wpus-usa-whirl-campaigning |
| wpus   | usa     | maytag     | campaigning | wpus-usa-mytag-campaigning |
| wpus   | usa     | amana      | campaigning | wpus-usa-amana-campaigning |
| wpus   | usa     | kitchenaid | campaigning | wpus-usa-khaid-campaigning |
| wpus   | usa     | jennair    | campaigning | wpus-usa-jnair-campaigning |
*/
export enum WhirlpoolCampaigningCheckoutSourceRefs {
    wpusUsaWhirlCampaigning = 'wpus-usa-whirl-campaigning',
    wpusUsaMytagCampaigning = 'wpus-usa-mytag-campaigning',
    wpusUsaAmanaCampaigning = 'wpus-usa-amana-campaigning',
    wpusUsaKhaidCampaigning = 'wpus-usa-khaid-campaigning',
    wpusUsaJnairCampaigning = 'wpus-usa-jnair-campaigning',
    WhirlpoolCampaigning = 'whirlpool_campaigning',
}

export enum CheckoutSourceRefEnum {
    WhirlpoolClientPortal = 'whirlpool_client_portal',
    GcE2ETesting = 'gc_e2e_testing',
    GcE2ETestingExpectedError = 'gc_e2e_testing_expected_error',
    ShadowTrafficHandler = 'gc_e2e_shadow_traffic',
}

export const CheckoutSourceRef = {
    ...CheckoutSourceRefEnum,
    ...WhirlpoolCampaigningCheckoutSourceRefs,
} as const

export type CheckoutSourceRefType =
    (typeof CheckoutSourceRef)[keyof typeof CheckoutSourceRef]

// Channel Source Data Schema
export const channelSourceData = z.object({
    checkoutSourceRef: z
        .nativeEnum(CheckoutSourceRef)
        .describe(
            'The source of the checkout, either whirlpool_campaigning or whirlpool_client_portal. Do NOT use anything prefix with gc_e2e_*, this is for internal checkout team testing only.',
        ),
    userId: z
        .string()
        .describe(
            'The user id of the agent taking the call, needed for commission purposes, and will be passed when creating a contract. Will default to GLOBALCHECKOUT if not present.',
        )
        .optional()
        .default('GLOBALCHECKOUT'),
    interactionId: z
        .string()
        .optional()
        .describe(
            'Optional Interaction ID that is passed when creating a contract. If not present, wil default to the transactionId returned in this response.',
        ),
})

export type ChannelSourceDataType = z.infer<typeof channelSourceData>
